<template>
  <div id="left-side">
    <header class="news-header">
        <Header/>
    </header>
    <div class="no-data" style="display: none">
        <div class="J_step01" style="display: none">
            <p>暂时无法加载新闻，请稍后再试</p>
            <a class="refresh_btn" @click.prevent="reload()" style="cursor:pointer" >点击刷新</a>
        </div>
        <div class="J_step02" style="display: none">
            <p><span class="load_icon"></span>正在加载...</p>
        </div>
    </div>
    <div class="mask" style="display: none"></div>
    <NewsList/>
  </div>
</template>

<script>
import Header from './components/Header'
import NewsList from './components/NewsList'

export default {
  name: 'left-side',
  components: {
    Header,
    NewsList
  },
	mounted() {
		this.$nextTick(() => {
			const wrap = document.querySelector('#left-side')
			wrap.addEventListener('mouseup', () => { window.lastMouseUpTime = new Date().getTime() })
			wrap.addEventListener('mousedown', () => { window.lastMouseDownTime  = new Date().getTime() })
		})
	},
  methods:{
    reload(){
      NewsList.reloadNews();
    }
  }
}
</script>
